import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  NavLink,
  useNavigate,
  Outlet,
  useLocation,
  Navigate,
} from "react-router-dom"; // Add Outlet
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import translations from "../assets/locals/translations";

import { fetchFile } from "../utils/fetchFile";
import {
  clearCurrentUserData,
  clearProfileDataSliceState,
} from "../redux/slices/profileSlice";
import { clearUserListState } from "../redux/slices/getUserListSlice";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { clearTokenBranchState } from "../redux/slices/tokenBranchChangeSlice";

// Keep ONLY the imports needed for the layout itself
import "../styles/HomeScreen.css";
import BreadCrumb from "./BreadCrumb/BreadCrumb";

// Your HomeScreen component is now the AppLayout
export default function AppLayout() {
  const currentLanguage = useSelector((state) => state.language.language);
  const [profileUrl, setProfileUrl] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const bottomDiv = useRef();
  const adminAsideRef = useRef();
  const toggleBtnRef = useRef();
  const [bottomDivState, setBottomDivState] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentBranch, setCurrentBranch] = useState([]);
  const profileDataState = useSelector((state) => state.profileData.profile);
  const allState = useSelector((state) => state);
  const tokenBranchState = useSelector(
    (state) => state.tokenBranchChangeState.tokenBranchState
  );

  const [agencyData, setAgencyData] = useState({
    agencyUrl: null,
    agencyName: "Agency Name",
  });

  const loadProfileImage = async (filename) => {
    const imageUrl = await fetchFile(filename);
    updateFavicon(imageUrl);
    setProfileUrl(imageUrl);
  };

  const updateFavicon = (url) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = url;
      document.head.appendChild(newLink);
    } else {
      link.href = url;
    }
  };

  useEffect(() => {
    const retrieveAgencyProfile = async () => {
      const url = `${process.env.REACT_APP_NODE_URL}/api/agency/get-agencybyid`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      setLoading(true);

      try {
        const response = await axios.get(url, config);
        const resultArray = response?.data?.result;

        if (resultArray && resultArray.length > 0) {
          // Map the array to an object using key_name
          const agencyProfile = resultArray.reduce((acc, curr) => {
            acc[curr.key_name] = curr.value;
            return acc;
          }, {});

          const agencyName = agencyProfile.name || "STPL – Industrial Laser";
          const agencyLogo = agencyProfile.logo;

          setAgencyData({
            agencyName,
            agencyUrl: agencyLogo,
          });

          document.title = agencyName || "CRM Pro";

          loadProfileImage(agencyLogo);
        } else {
          document.title = "STPL – Industrial Laser";
        }
      } catch (error) {
        console.error("Error retrieving agency profile:", error);
        document.title = "STPL – Industrial Laser";
      } finally {
        setLoading(false);
      }
    };

    retrieveAgencyProfile();
  }, []);

  useEffect(() => {
    if (tokenBranchState.isSuccess) {
      if (tokenBranchState.data.isSuccess) {
        localStorage.setItem("rbacToken", tokenBranchState.data.result);

        console.log("tokenBranchState &&&&&&&&&&&&&&", tokenBranchState);
        // dispatch(getProfileData(tokenBranchState.data.result))
        dispatch(clearTokenBranchState());
        console.log("please redirect to home");
        navigate("/home");

        window.location.reload();
      }
    }
  }, [tokenBranchState]);

  useEffect(() => {
    const collapse = document.getElementsByClassName("activeLink");
    if (collapse.length > 0) {
      collapse[0].parentElement.parentElement.parentElement.classList.add(
        "show"
      );
    }
  }, []);

  useEffect(() => {
    console.log(
      "profileDataState",
      profileDataState.currentUserData,
      "profile.........."
    );
    if (
      profileDataState.isSuccess &&
      profileDataState.currentUserData.isSuccess
    ) {
      const rolesArray = [];
      Array.from(profileDataState.currentUserData.result.features).filter(
        (i) => {
          rolesArray.push(i.feature);
        }
      );
      localStorage.setItem("rolesArray", rolesArray);
      localStorage.setItem(
        "userData",
        JSON.stringify(profileDataState.currentUserData.result)
      );
      dispatch(clearProfileDataSliceState());
      // navigate('/home')
    } else if (profileDataState.isError) {
      dispatch(setShowMessage("Server is temporarily unavailable"));
    }
  }, [profileDataState]);

  useEffect(() => {
    if (bottomDivState) {
      let handler = (event) => {
        if (!bottomDiv.current.contains(event.target)) {
          setBottomDivState(false);
        }
      };
      document.addEventListener("mousedown", handler);
      return () => {
        document.removeEventListener("mousedown", handler);
      };
    }
  }, [bottomDivState]);

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundColor = "#edf1f4";
  }, []);

  const checkTabGrant = useCallback((pathAr) => {
    let success = false;
    const rolesArray = localStorage.getItem("rolesArray");
    const checkList = rolesArray.split(",");
    pathAr.forEach((element) => {
      if (checkList.includes(element)) {
        success = true;
      }
    });
    return success;
  }, []);
  function logOutHandler() {
    localStorage.clear();
    dispatch(clearUserListState());
    dispatch(clearProfileDataSliceState());
    dispatch(clearCurrentUserData());
    dispatch(clearCurrentUserData());
    dispatch(clearProfileDataSliceState());

    navigate("/login");
    <NavLink
      className={({ isActive }) => (isActive ? "activeLink" : "")}
      to="login"
    >
      {translations[currentLanguage].products}
    </NavLink>;
  }
  function getDateTime(time) {
    const data = new Date(time);
    const newDate = data.toDateString("DD-MM-YYYY");
    const newTime = data.toLocaleTimeString();
    return `${newDate} ${newTime}`;
  }

  function branchListChange(e) {
    let selectedBranchId = e.target.value;
    localStorage.setItem("currentBranchId", selectedBranchId);
    // dispatch(tokenBranchChangeDb(selectedBranchId));
  }
  function toggleHandler() {
    if (document.getElementById("root").classList.contains("toggleSideBar")) {
      document.getElementById("root").classList.remove("toggleSideBar");
    } else {
      document.getElementById("root").classList.add("toggleSideBar");
    }
  }
  const handleLogoClick = () => {
    navigate("/home/dashboard");
  };

  const openDashboard = () => {
    navigate("/home/dashboard");
  };
  useEffect(() => {
    let jsonData = localStorage.getItem("dealersList");
    let branchesList = JSON.parse(jsonData);
    // set here branchesList
    setCurrentBranch(branchesList);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <aside ref={adminAsideRef} className="asideNav">
        <button
          onClick={toggleHandler}
          ref={toggleBtnRef}
          className="toggleBtn"
        >
          <main className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="headSvg bi bi-chevron-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </main>
        </button>
        <main className="asideMain">
          {/* site logo and name */}
          <div className="shadow rounded">
            <div className="logoSection">
              <img src={profileUrl} alt="Site Logo" className="siteLogo" />
              <h1 className="siteName">
                {agencyData.agencyName
                  ? agencyData.agencyName
                  : agencyData.agencyName === ""
                  ? "STPL – Industrial Laser"
                  : "CRM"}
              </h1>
            </div>
          </div>
          <section className="outerSection">
            <ul id="accordionExample" className="outUl">
              {checkTabGrant(["profile"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#home-collapseOne"
                    aria-expanded="false"
                    aria-controls="home-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="headSvg bi bi-house"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
                    </svg>
                    <span onClick={openDashboard}>
                      {translations[currentLanguage].home}
                    </span>
                  </button>
                  <div
                    id="home-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["dashboard"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/dashboard"
                          >
                            {translations[currentLanguage].dashboard}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["user-profile"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/profiles/user"
                          >
                            {translations[currentLanguage].profile}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["agency"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/profile/agency"
                          >
                            {translations[currentLanguage].agencyp}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["sales"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sale-collapse"
                    aria-expanded="false"
                    aria-controls="sale-collapse"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-graph-up-arrow"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                      />
                    </svg>
                    <span>Sales</span>
                  </button>
                  <div
                    id="sale-collapse"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="sale/leads"
                          >
                            Leads
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="sale/data"
                          >
                            Data
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="sales/add"
                          >
                            Add Data
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["production"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#prod-collapse"
                    aria-expanded="false"
                    aria-controls="prod-collapse"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-diagram-3-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6 2a1 1 0 0 0-1 1v2H3a1 1 0 0 0-1 1v2h3V6h2v2h3V6h2v2h3V6a1 1 0 0 0-1-1h-2V3a1 1 0 0 0-1-1H6zm1 8H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v-4zm7 0h-5v4h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z" />
                    </svg>
                    <span>Production</span>
                  </button>
                  <div
                    id="prod-collapse"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["production"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="production/order"
                          >
                            Order
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {/* {checkTabGrant(["inventory"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#stock-collapseOne"
                    aria-expanded="false"
                    aria-controls="stock-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                    >
                      <path d="M3 13v-2l1-3 1-2h14l1 2 1 3v2h-1v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1H9v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4H3zm2-4h14l-1-2H6l-1 2zm0 2v4h1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h1v-4H5z" />
                    </svg>

                    <span>Inventory</span>
                  </button>
                  <div
                    id="stock-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["inventory"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="stock/billing"
                          >
                            Billing
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["inventory"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="stocks"
                          >
                            Stocks
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["inventory"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="delivery/steps"
                          >
                            Pipeline
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["inventory"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="delivery/data"
                          >
                            Delivery
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )} */}
              {checkTabGrant(["service"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#service-collapseOne"
                    aria-expanded="false"
                    aria-controls="service-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-grid"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
                    </svg>
                    <span>{translations[currentLanguage].service}</span>
                  </button>
                  <div
                    id="service-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["service"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="service/service"
                          >
                            Service
                          </NavLink>
                        </li>
                      )}

                      {/* {checkTabGrant(["service"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="service/servicing"
                          >
                            Servicing
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["products"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/due"
                          >
                            Services Due
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["products"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/sold"
                          >
                            Sold Out
                          </NavLink>
                        </li>
                      )} */}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["manage"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#manage-collapseOne"
                    aria-expanded="false"
                    aria-controls="manage-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-diagram-3-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                      />
                    </svg>
                    <span> {translations[currentLanguage].management}</span>
                  </button>
                  <div
                    id="manage-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["manage"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/manage"
                          >
                            {translations[currentLanguage].manage}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["task"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/mytask"
                          >
                            {translations[currentLanguage].mytask}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["report"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#reports-collapseOne"
                    aria-expanded="false"
                    aria-controls="reports-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                      width="24"
                      height="24"
                    >
                      <path d="M4 0h6l4 4v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6 1.5V5h3.5L10 1.5zM3 2v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h-4V2H4a1 1 0 0 0-1 1z" />
                    </svg>
                    <span>Reports</span>
                  </button>
                  <div
                    id="reports-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["report"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="reports"
                          >
                            All Reports
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["configuration", "roles", "users"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#admin-collapseOne"
                    aria-expanded="false"
                    aria-controls="admin-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-person-gear"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                    </svg>
                    <span>{translations[currentLanguage].administration}</span>
                  </button>
                  <div
                    id="admin-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["roles"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="administration/roles"
                          >
                            {translations[currentLanguage].roles}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["users", "add-user", "edit-user"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="administration/users"
                          >
                            Users
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["configuration"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="administration/configuration"
                          >
                            {translations[currentLanguage].configuration}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
            </ul>
          </section>

          <div className="mb-3">
            <section className="profileSection outerSection">
              <div
                onClick={() => {
                  bottomDivState
                    ? setBottomDivState(false)
                    : setBottomDivState(true);
                }}
                id="asideProfilTab"
                type="button"
                className="d-flex flex-row"
              >
                <div className="myTextContainer">
                  <span className="text-uppercase">
                    {Object.keys(profileDataState.currentUserData).length
                      ? `${profileDataState?.currentUserData?.result?.first_name.slice(
                          0,
                          1
                        )}`
                      : "A"}
                  </span>
                </div>
                <div className="userNameDis ps-2 d-flex align-items-center ">
                  <h6 className="m-0 text-uppercase text-white">
                    {Object.keys(profileDataState.currentUserData).length
                      ? `${profileDataState?.currentUserData.result.first_name} ${profileDataState?.currentUserData.result.last_name}`
                      : "User"}
                  </h6>
                </div>
              </div>
              {bottomDivState && (
                <div ref={bottomDiv} className="logoutSideBar">
                  <div className="d-flex justify-content-between">
                    <h6 className="text-white">
                      Email :{" "}
                      {Object.keys(profileDataState.currentUserData).length >
                        0 &&
                        `${profileDataState?.currentUserData.result.email}`}
                    </h6>
                    <button
                      onClick={() => {
                        setBottomDivState(false);
                      }}
                      className="svgBtn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        className="bi bi-x-lg"
                        viewBox="0 0 16 16"
                      >
                        gg
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                      </svg>
                    </button>
                  </div>
                  <h6 className="text-white mt-2">
                    Current branch :
                    <select
                      defaultValue={localStorage.getItem("currentBranchId")}
                      onChange={branchListChange}
                      className="mt-2 mySelectBox"
                      name=""
                      id=""
                    >
                      {currentBranch &&
                        currentBranch.length > 0 &&
                        currentBranch.map((branch, index) => {
                          return (
                            <option
                              className="branch-text-list"
                              key={index}
                              value={branch.id}
                            >
                              {branch.name}
                            </option>
                          );
                        })}
                    </select>
                  </h6>
                  <div className="mt-3 d-flex flex-column">
                    <div className="d-flex flex-wrap align-items-center border-bottom pb-2">
                      <div className="myTextContainer">
                        <span className="text-uppercase">
                          {Object.keys(profileDataState.currentUserData)
                            .length > 0
                            ? `${profileDataState?.currentUserData?.result?.first_name.slice(
                                0,
                                1
                              )}`
                            : "A"}
                        </span>
                      </div>
                      <span className="pt-2 ps-2 text-white myH7">
                        Last login :{" "}
                        {Object.keys(profileDataState.currentUserData).length >
                          0 &&
                        profileDataState?.currentUserData.result.last_login !=
                          null
                          ? getDateTime(
                              profileDataState?.currentUserData.result
                                .last_login
                            )
                          : "first time logged in"}
                      </span>
                    </div>
                    <div className="mt-3 d-flex justify-content-end">
                      <button
                        className="myBtn py-1 px-3"
                        onClick={logOutHandler}
                        href=""
                      >
                        {translations[currentLanguage].logout}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </main>
      </aside>

      <main id="mainContainer">
        <BreadCrumb />
        <div className="container-fluid">
          <Outlet />
        </div>
      </main>
    </>
  );
}
